import { render, staticRenderFns } from "./ReceiptOfSamples.vue?vue&type=template&id=78258b5e&scoped=true&"
import script from "./ReceiptOfSamples.vue?vue&type=script&lang=js&"
export * from "./ReceiptOfSamples.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptOfSamples.vue?vue&type=style&index=0&id=78258b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78258b5e",
  null
  
)

export default component.exports